import { animateSequence } from "./sequence.mjs";
import { animateSubject } from "./subject.mjs";
import { GroupAnimationWithThen } from "../../../../../../../motion-dom@12.10.5/external/motion-dom/dist/es/animation/GroupAnimationWithThen.mjs";
function isSequence(value) {
  return Array.isArray(value) && value.some(Array.isArray);
}
function createScopedAnimate(scope) {
  function scopedAnimate(subjectOrSequence, optionsOrKeyframes, options) {
    let animations = [];
    if (isSequence(subjectOrSequence)) {
      animations = animateSequence(subjectOrSequence, optionsOrKeyframes, scope);
    } else {
      animations = animateSubject(subjectOrSequence, optionsOrKeyframes, options, scope);
    }
    const animation = new GroupAnimationWithThen(animations);
    if (scope) {
      scope.animations.push(animation);
    }
    return animation;
  }
  return scopedAnimate;
}
const animate = createScopedAnimate();
export {
  animate,
  createScopedAnimate
};
